
import { defineComponent, ref, watch } from 'vue'
export default defineComponent({
  name: 'CollapseGroup',
  emits: ['change'],
  props: {
    // 初期でcollapseを開くかどうか
    isOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props, context) {
    const activeName = ref<string>('')

    watch(
      () => props.isOpen,
      () => {
        activeName.value = props.isOpen ? 'item' : ''
      },
      { immediate: true }
    )

    return {
      activeName,
      change: () => {
        context.emit('change')
      },
    }
  },
})
